import { gsap } from "../../libs/gsap-3.6.1/esm";
import { ScrollTrigger } from "../../libs/gsap-3.6.1/esm/ScrollTrigger";

const STICKYMENU = document.querySelector(".js-anchor-menu");

gsap.registerPlugin(ScrollTrigger);

function AnchorMenuDirection() {
	ScrollTrigger.create(
		{
			trigger: "body",
			start: "75px",
			end: "bottom bottom",
			onUpdate: self => {
				if (self.direction === 1) {
					if( STICKYMENU !== null ) {
						STICKYMENU.classList.add("is-top");
					}

				} else {
					if( STICKYMENU !== null ) {
						STICKYMENU.classList.remove("is-top");
					}
				}
			}
		}
	);
}

function AnchorMenuPosition() {
	let offset = document.documentElement.scrollTop;
	let anchorMenu = $('.js-anchor-menu');
	let anchorMenuWrapper = anchorMenu.closest('.js-anchor-menu-wrapper');

	if( anchorMenuWrapper.length == 0 ) {
		return;
	}

	let anchorMenuOffset = $(anchorMenuWrapper).offset().top;

	if (offset >= anchorMenuOffset) {
		if( STICKYMENU !== null ) {
			$(anchorMenu).addClass('is-sticky');
		}
	} else {
		if( STICKYMENU !== null ) {
			$(anchorMenu).removeClass('is-sticky');
		}
	}
}

function AnchorMenuSticky() {
	AnchorMenuPosition();
	AnchorMenuDirection();

	$(window).scroll(function () {
		AnchorMenuPosition();
	})
}

export {
	// AnchorMenuDirection,
	AnchorMenuSticky
};